export class RegistrationLink {
    name: string;
    email: string;
}
